import { apiRequest } from './client'
import type { OrganizationDto } from './types'

export type UpdateOrganizationRequest = {
  legalName: string
  tradeName: string
  ogrn: string
  city: string
  horecaType?: string | null
  productTypeIds?: number[]
  /**
   * Контактное лицо. undefined — не отправлять (значение на сервере не меняется);
   * пустая строка — очистить.
   */
  contactName?: string
  contactPhone?: string
}

export type CreateFirstOrganizationRequest = {
  legalName: string
  tradeName: string
  ogrn: string
  city: string
}

export const createFirstOrganization = (request: CreateFirstOrganizationRequest) =>
  apiRequest<OrganizationDto>('/organizations/first', {
    method: 'POST',
    body: {
      legal_name: request.legalName,
      trade_name: request.tradeName,
      ogrn: request.ogrn,
      city: request.city,
    },
  })

export const updateOrganization = (organizationId: number, request: UpdateOrganizationRequest) =>
  apiRequest<OrganizationDto>(`/organizations/${organizationId}`, {
    method: 'PATCH',
    body: {
      legal_name: request.legalName,
      trade_name: request.tradeName,
      ogrn: request.ogrn,
      city: request.city,
      horeca_type: request.horecaType ?? undefined,
      product_type_ids: request.productTypeIds ?? undefined,
      // Ключ контакта ставим только если значение передано. Сервер отличает «поле не
      // прислано» (не трогать) от пустой строки (очистить), и это различие не должно
      // зависеть от того, как сериализатор обходится с undefined.
      ...(request.contactName !== undefined ? { contact_name: request.contactName } : {}),
      ...(request.contactPhone !== undefined ? { contact_phone: request.contactPhone } : {}),
    },
  })
